var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Accordion, Button, Row, Col } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useFormContext } from "react-hook-form";
import { RecekTextField, RecekOnixItemPicker } from "../inputs";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { minorUnitsToPriceInput } from "../../utils/priceUtils";
import { preferredOnix } from "../../utils/selectMappers";
/** ONIX Currency (codetable 96) code for Czech koruna ("Kč"). */
var CURRENCY_CZK = "CZK";
export var ProductPriceSection = function (_a) {
    var showPrice = _a.showPrice, onShowPriceChange = _a.onShowPriceChange, open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue;
    var _c = useOnixOptions(), priceTypeTable = _c.priceTypeTable, currencyTable = _c.currencyTable, priceTypeStatus = _c.priceTypeStatus, currencyStatus = _c.currencyStatus;
    var handleRemovePrice = function () {
        onShowPriceChange(false);
        setValue("price", undefined);
    };
    var handleAddPrice = function () {
        onShowPriceChange(true);
        setValue("price", {
            // Default the currency to "Kč" (CZK) by its ONIX code (96/CZK) rather
            // than by array index, which depends on the codetable's sort_order.
            currency: preferredOnix(currencyTable, CURRENCY_CZK),
            type: priceTypeTable === null || priceTypeTable === void 0 ? void 0 : priceTypeTable.onixCodetableItems[0],
        });
    };
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.product.accordion.price",
        }), open: open, onToggle: onToggle },
        !showPrice && (React.createElement(Button, { buttonStyle: "default", onClick: handleAddPrice },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.price.set" }))),
        showPrice && (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Controller, { control: control, name: "price.type", render: function (_a) {
                            var _b, _c;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.price.type.label", dataOptions: (_b = priceTypeTable === null || priceTypeTable === void 0 ? void 0 : priceTypeTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: priceTypeStatus, value: field.value, onChange: field.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                        } }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Controller, { control: control, name: "price.amount", render: function (_a) {
                            var _b, _c;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekTextField, __assign({}, field, { value: typeof field.value === "number"
                                    ? minorUnitsToPriceInput(field.value)
                                    : ((_b = field.value) !== null && _b !== void 0 ? _b : ""), labelId: "ui-br-agency.product.price.amount.label", type: "text", inputMode: "decimal", placeholder: formatMessage({
                                    id: "ui-br-agency.product.price.amount.placeholder",
                                }), error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true })));
                        } }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Controller, { control: control, name: "price.currency", render: function (_a) {
                            var _b, _c;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.price.currency.label", dataOptions: (_b = currencyTable === null || currencyTable === void 0 ? void 0 : currencyTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: currencyStatus, value: field.value, onChange: field.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                        } }))),
            React.createElement(Button, { buttonStyle: "danger", onClick: handleRemovePrice },
                React.createElement(FormattedMessage, { id: "ui-br-agency.product.price.remove" }))))));
};
